import classes from './no-results-found.module.scss'

export const NoResultsFound = () => (
  <div className={classes.root}>
    <strong>No results found</strong>
  </div>
)
